import styled from 'styled-components'

export const FadeInWrapper = styled.div<{visible: boolean}>`
  transition: opacity 0.3s ease-in;
  opacity: ${({visible}): number => (visible ? 1 : 0)};
`
